import { render, staticRenderFns } from "./AlertHandler.vue?vue&type=template&id=24744185&scoped=true"
import script from "./AlertHandler.vue?vue&type=script&lang=ts"
export * from "./AlertHandler.vue?vue&type=script&lang=ts"
import style0 from "./AlertHandler.vue?vue&type=style&index=0&id=24744185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24744185",
  null
  
)

export default component.exports